import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.enableSentry) {
    Sentry.init({
        dsn: "https://79eb5c7a79e22bfb6207f1008aef966e@sentry.scponline.it/33",
        sendDefaultPii: true
    })
}

registerLocaleData(localeIt);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
